import { CoreBox, CoreTypography } from '@youscience/core';

import IPEDSLogo from '@images/IPEDS-logo.svg?react';

import { StyledIPEDSContainer, StyledIPEDSInner } from './IPEDS.styles';

export const IPEDS = () => {
  return (
    <StyledIPEDSContainer>
      <StyledIPEDSInner>
        <CoreTypography variant="caption">
          College Data Provided by: IPEDS (Integrated Postsecondary Education Data System) and NCES (U.S. Department of
          Education. Institute of Education Sciences, National Center for Education Statistics)
        </CoreTypography>

        <CoreBox>
          <IPEDSLogo />
        </CoreBox>
      </StyledIPEDSInner>
    </StyledIPEDSContainer>
  );
};
